module.exports = __webpack_public_path__ + "static/media/mobileUp.ec553383.mp3";